/**
 * used to update the theme
 */
// let params = {
//     page: "event_tickets",
//     data: {
//         group_by_entity: true
//     }
// }
/**
 * Sends update to the users theme manager to save that page property value
 * @param {Object} params.data  Data containing the property of the theme and value
 * @param {string} params params.page   the name of the page
 * @param {string} params params.prop   the prop of the page
 * @param {Object} params   -   the reference of the page and its theme params
 */
export default function updateTheme(params) {

    let theme_route = document.querySelector('body').getAttribute('data-theme-route');
    // console.log('updateTheme', params);
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
        }
    });
	/** @namespace params.prop */
	/** @namespace params.page */
	let data = {
        'page': params.page,
        'prop': params.prop,
        'data': params.data
    };
    // console.log('data', data);
    axios.post(theme_route, data)
        .then(function (response) {
            if (response.data.success) {

                console.log('updateTheme response.data.success', response.data);

            }
        })
        .catch(function (response) {
            console.log('response.data.failed', response);
        });

}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/theme-manager.js